import { getRequest, postRequest } from '../config/axios-config';
import { Api_routes, server_url } from '../config/API_Routes';

export const getChangeLogData = (skip, activeTag = '') => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getChangeLogs +
          `?skip=${skip}` +
          `&tag=${activeTag}`
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const updateChangelogLastViewedVersion = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateLastViewedVersion,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};
